<template>
    <v-card rounded="lg" class="lightgrey superlead-card">
        <v-toolbar tile dark class="bg-gradient">
            <v-btn x-large depressed color="white" class="ml-2" text @click.native="cancel(false)">
                <v-icon dark small class="mr-2">$prev</v-icon> {{$t('back')}}
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>{{ superlead.id ? ($t('lead_detail') + ' : #S' + superlead.id) : $t('create_a_lead') }}</v-toolbar-title>
            <v-spacer></v-spacer>
                <!-- <v-btn depressed outlined color="white" class="mr-3" @click="cancel(false)">
                {{$t('back')}}
            </v-btn> -->
            <v-btn depressed outlined color="white" :loading="loader" dark @click="checkBeforeUpdate" :disabled="btnDisabled || formDisabled">
                {{$t('recordRdvLabel')}}
            </v-btn>
        </v-toolbar>
        
        <v-card-text class="pa-8">
            <v-row>
                <v-col cols="6" class="d-flex align-center">
                    <v-select v-model="superlead.temperature" :items="superleadTemperatures" item-value="name" class="mr-6 mt-0 pt-0 icon_selector" solo hide-details>
                        <template v-slot:item="data">
                            <v-icon :color="data.item.color" class="mr-4">${{ data.item.icon }}</v-icon>
                            {{ $t(data.item.name) }}
                        </template>

                        <template v-slot:selection="data">
                            <v-icon :color="data.item.color">${{ data.item.icon }}</v-icon>
                        </template>
                    </v-select>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-chip v-on="on" outlined class="mr-4" :color="superlead.is_enriched == 1 ? 'info' : 'grey'">{{ superlead.is_enriched == 1? 'Enrichi' : 'Non Enrichi' }}</v-chip>
                        </template>
                        <div v-if="superlead.is_enriched == 1">
                            <span v-if="enrichedTooltipItems.length > 0">
                                <ul class="mb-0 pl-4">
                                    <li v-for="(enrichedItem, index) in enrichedTooltipItems" :key="index">
                                        {{ enrichedItem }}
                                    </li>
                                </ul>
                            </span>
                            <span v-else>Aucunes données d'enrichissement trouvées</span>
                        </div>
                        <span v-else>Lead non enrichi</span>
                    </v-tooltip>

                    <v-alert v-if="reportNumber > 0 || (demandNumber > 1 && superlead && superlead.custom_status && (['WAITING', 'TO_DEAL', 'SUFFERING']).includes(superlead.custom_status))" class="mb-0 w-full" dense border="left" color="info" text>
                        <div v-if="reportNumber > 0">{{ $t("leadReportNumber", {var: reportNumber}) }}</div>
                        <div v-if="demandNumber > 1 && superlead && superlead.custom_status && (['WAITING', 'TO_DEAL', 'SUFFERING']).includes(superlead.custom_status)">{{ $t("DemandNumber", {var: demandNumber}) }} <a class="info--text" @click="goToContact" style="text-decoration: underline;">{{ $t('goToDemands') }}</a></div>
                    </v-alert>
                </v-col>
                <v-col cols="6" align="right">
                    <v-tooltip bottom :disabled="!btnDisabled">
                        <template v-slot:activator="{ on }">
                            <div v-on="on" class="d-flex flex-wrap justify-end">
                                <v-btn v-if="$func.hasRight('exchange/get')" dense :disabled="btnDisabled || formDisabled" @click="launchGetInTouch" :loading="launchGetInTouchLoader"  depressed class="mr-2 mb-2" color="primary"><v-icon left dark small>$mailbox_flag_up_l</v-icon>{{ $t('getintouch') }}</v-btn>
                                <v-btn dense :disabled="btnDisabled || formDisabled" @click="launchTransfer" :loading="launchTransferLoader"  depressed class="mr-2 mb-2" color="secondary"><v-icon left dark small>$exchange_l</v-icon>{{ $t('transfer') }}</v-btn>
                                <v-btn dense :disabled="btnDisabled || formDisabled" @click="launchAbandon" :loading="launchAbandonLoader"  depressed class="mr-2 mb-2" color="error"><v-icon left dark small>$close</v-icon>{{ $t('abandon') }}</v-btn>
                                <v-btn dense :disabled="btnDisabled || formDisabled" @click="launchReport" :loading="launchReportLoader"  depressed class="mr-2 mb-2" color="warning"><v-icon left dark small>$alarm_clock_l</v-icon>{{ $t('report') }}</v-btn>
                                <v-btn dense v-if="$func.hasRight('lead/qualify')" :disabled="btnDisabled || formDisabled || qualifDisabled" @click="launchQualif" :loading="launchQualifLoader" class="mr-2"  depressed color="success"><v-icon left dark small>$check_l</v-icon>{{ $t('qualif') }}</v-btn>
                            </div>
                        </template>
                        <span>{{ $t('contact_and_rdv_or_demand_are_required') }}</span>
                    </v-tooltip>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="8">
                    <v-card class="" rounded="lg">
                        <v-card-text class="heading pa-8">
                            <div class="header-div">
                                <v-icon medium color="secondary" class="mr-5">$user_d</v-icon>
                                <span>
                                    <span>{{ $t('in_charge_of_the_lead') }}</span>
                                    <div class="label mt-1">{{ superlead.affected_user &&  typeof superlead.affected_user === 'object' ? (superlead.affected_user.is_presta ? superlead.affected_user.social_raison : (superlead.affected_user.firstname + ' ' + superlead.affected_user.name)) : $t('poollead') }}</div>
                                </span>
                            </div>
                            <div class="header-div">
                                <v-icon medium color="secondary" class="mr-5">$mapmarker_d</v-icon>
                                <span>
                                    <span>{{ $t('attached_to') }}</span>
                                    <div class="label mt-1">{{ superlead.entity_id.label }}</div>
                                </span>
                            </div>
                            <div class="header-div">
                                <v-icon medium color="secondary" class="mr-5">$bullhorn_d</v-icon>
                                <span>
                                    <span>{{ $t('operation') }}</span>
                                    <div class="label mt-1">{{ superlead.operation_id.label }}</div>
                                </span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="4">
                    <SHistory :superlead="superlead" @changeReportNumber="changeReportNumber" :key="historyKey" />
                </v-col>
            </v-row>
            

            <v-row>
                <v-col cols="8">
                    <SContact :superlead="superlead" :superleadBase="superleadBase" :formDisabled="!(this.$func.hasRight('lead/add') && this.newSuperlead) && formDisabled" ref="sContact" @reloadDemands="demandKey++;" />
                </v-col>

                <v-col cols="4">
                    <SRdv :superlead="superlead" :operationData="operationData" :formDisabled="formDisabled" @checkOperationData="checkOperationData" ref="sRdv" />   
                </v-col>
            </v-row>

            <v-row :key="'demandPart_'+demandKey">
                <v-col cols="4" v-for="(demand, index) in superlead.demands" :key="index" v-if="demand" :style="['rendez-vous', 'passage', 'inscription'].includes(demand.type) ? 'display:none;' : ''">
                    <SDemand :superlead="superlead" :superleadBase="superleadBase" :formDisabled="formDisabled" :demand="demand" :index="index" @removeDemand="removeDemand(index)" :ref="'SDemand_'+index" :demandTypes="demandTypes"/>        
                </v-col>
                <v-col cols="4">
                    <SDemandAdd :superlead="superlead" @addDemand="addDemand" :formDisabled="formDisabled" :demandTypes="demandTypes"/>
                </v-col>
            </v-row>
        </v-card-text>

        <v-dialog v-model="confirmExitDialog" max-width="700">
            <v-card>
                <v-toolbar flat>
                    <v-toolbar-title>{{ $t('checkBeforeExitFormWithoutSave') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn depressed text class="square" @click="confirmExitDialog = false">
                        <v-icon small> $close </v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-actions class="py-6">
                    <v-spacer></v-spacer>
                    <v-btn depressed color="lightgrey" @click="cancel(true)">{{ $t('exitWithoutSave') }}</v-btn>
                    <v-btn depressed color="primary" @click="checkBeforeUpdate">{{ $t('saveAndExit') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog class="rounded-lg" persistent width="1200" v-model="transferDialog" scrollable>
            <v-card>
                <v-toolbar tile flat dark  class="bg-gradient" >
                    <div style="display:flex; width:100%; align-items:center; justify-content:space-between;">
                        <div>
                            <v-toolbar-title>{{$t('transferCall')}}</v-toolbar-title>
                        </div>
                        <div>
                            <v-btn outlined dark depressed @click.native="transferDialog = false">{{$t('cancel')}}</v-btn>
                            <v-btn :disabled="team.length === 0" outlined dark depressed @click="transfer" :loading="transferLoader" class="ml-3">{{$t('confirm')}}</v-btn>
                        </div>
                    </div> 
                </v-toolbar>
                <v-card-text class="mt-4">
                    <div v-if="$store.state.auth.user.is_presta">
                        <p style="width:100%;" class="label mb-1"><b>{{ $t('Transfert_choiceTitle') }}<span class="error--text"> *</span></b></p>
                        <v-btn-toggle dense group borderless :mandatory="true" v-model="transfert_choice" active-class="btnActive" class="mb-4">
                            <v-btn dense dark depressed class="white--text btnSpec" :style="transfert_choice == property.value ? 'background-color:var(--v-primary-base) !important;' : 'background-color:var(--v-darkgrey-base) !important;'" v-show="!property.hide" v-for="property in transfert_choices" :key="property.value" :value="property.value"> 
                                {{$t(property.label)}}
                            </v-btn>
                        </v-btn-toggle>
                    </div>
                    <v-simple-table v-if="team.length > 0">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left"></th>
                                    <th class="text-left">{{$t('interlocutors')}}</th>
                                    <th class="text-left"></th>
                                    <th class="text-left">{{$t('brands')}}</th>
                                    <th class="text-left">{{$t('phones')}}</th>
                                    <th class="text-left">{{$t('leadReceiveToday')}}</th>
                                    <th class="text-left">{{$t('leadReceiveLastWeek')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in team" :key="user.id" @click="selectUser(user.id)">
                                    <td>
                                        <div style="display:flex; align-items:center;">
                                            <input type="radio" class="radioButton" :id="'radio_'+user.id" :value="user.id" v-model="userRadio" :name="'userRadio'"/>
                                        </div>
                                    </td>
                                    <td>
                                        <b>{{ user.firstname }} {{ user.name }}</b>
                                        <div v-if="user.poste && user.poste.length > 0">{{user.poste.join(', ')}}</div>
                                    </td>
                                    <td>
                                        <div v-for="(univ, index) in user.univers" class="my-1" :key="'univers_'+index">
                                            <v-chip small color="primary" outlined>{{univ}}</v-chip>
                                        </div>
                                    </td>
                                    <td>
                                        <span v-if="user.brands">
                                            {{ user.brands.join(', ') }}
                                        </span>
                                    </td>
                                    <td>
                                        <div v-for="(phone, index) in user.phones" class="my-1" :key="'phone_'+index">
                                            <v-chip small color="primary" outlined>{{phone.type}}</v-chip>
                                            {{phone.number}}
                                        </div>
                                    </td>
                                    <td class="text-center">
                                       <b>{{user.leadReceiveToday}}</b>
                                    </td>
                                    <td class="text-center">
                                        <b>{{user.leadReceiveWeek}}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <v-alert v-else class="mt-2 mb-0" border="left" color="info" text>
                        {{ $t('noUserForTransfert') }}
                    </v-alert>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="checkBeforeDialog" persistent width='800'>
          <v-card>
            <v-toolbar tile flat dark class="bg-gradient">
                 <v-toolbar-title>{{checkBeforeDialogTitle}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn outlined dark depressed @click.native="cancelDialog" class="ml-3">{{$t('cancel')}}</v-btn>
                <v-btn outlined dark depressed @click="saveAndClose()" class="ml-3">{{$t('confirm')}}</v-btn>
            </v-toolbar>
            <v-card-text class="pt-4">
                <v-row>
                  <v-col cols="12">
                    <v-alert color="warning" dense text border="left" class="mb-0">
                      <span v-html="checkBeforeDialogText"></span>
                    </v-alert>
                  </v-col>
                </v-row>
            </v-card-text>
          </v-card>
      </v-dialog>
        <FormDialogComponent v-if="form" ref="componentForm" :form="form" :action="'SET_DATA'"/>
    </v-card>
</template>

<script>
import FormDialogComponent from "@/components/dialogs/FormDialogComponent";
import GenericDataService from '@/services/GenericDataService'
import SContact from "@/components/superleadComponent/cards/s-contact";
import SRdv from "@/components/superleadComponent/cards/s-rdv";
import SDemand from "@/components/superleadComponent/cards/s-demand";
import SDemandAdd from "@/components/superleadComponent/cards/s-demand-add";
import SHistory from "@/components/superleadComponent/cards/s-history";
import getForm from "@/mixins/mixins";

export default {
    name: "superleadComponent",
    props: [],
    components: { FormDialogComponent, SContact, SRdv, SDemand, SDemandAdd, SHistory },
    mixins: [getForm],
    data() {
        return {
            checkBeforeDialog: false,
            checkBeforeDialogTitle: "",
            checkBeforeDialogText: "",
            superlead: {},
            resolve: null,
            btnDisabled: true,
            formDisabled: true,
            demandKey:0,
            confirmExitDialog: false,
            transferDialog: false,
            transfert_choices: [
                { "value": "CONCESS", "label": "transfert_choice_CONCESS_label" },
                { "value": "TEAM", "label": "transfert_choice_TEAM_label" }
            ],
            transfert_choice: "CONCESS",
            team: [],
            userRadio: null,
            loader: false,
            transferLoader: false,
            launchTransferLoader: false,
            launchGetInTouchLoader: false,
            launchReportLoader: false,
            launchAbandonLoader: false,
            launchQualifLoader: false,
            form: null,
            operationData: false,
            newSuperlead: false,
            reportNumber:0,
            demandNumber:0,
            mainTypeSetted: false,
            socketServer: null,
            historyKey: 0,
            initDemandCount : false,
            demandTypes: [],
            superleadTemperatures: [],
        }
    },
    created() {
        this.superlead =  this._.cloneDeep(this.superleadBase);
        this.$watch('superlead.rdv', () => {
            if(this.socketServer) {
                this.socketServer.send(JSON.stringify({
                    type: 'rdv',
                    account: this.$store.state.auth.currentAccountId,
                    operation: (this.superlead.operation_id.id ? this.superlead.operation_id.id : this.superlead.operation_id),
                    rdv: this.superlead.rdv
                }));
            }
        }, { deep: true });
        
        if (!!!this.superleadBase.id) {
            this.newSuperlead = true;
        }
        this.checkOperationData();
        if(this.superlead.script) {
            this.$store.dispatch("auth/SET_OPEN_CALL_SCRIPT_DRAWER_WITHOUT_ID", true);
            this.$store.dispatch("auth/SET_TEMPLATE_FOR_CALL_SCRIPT_DRAWER", this.superlead.script);
        }
        
        const socketServer = new WebSocket(process.env.VUE_APP_WEBSOCKET_URL);
        this.socketServer = socketServer;
        
        socketServer.onopen = (e) => {
            if (this.newSuperlead && this.superlead.rdv && this.superlead.rdv.operation_id) {
                if(this.socketServer) {
                    this.socketServer.send(JSON.stringify({
                        type: 'rdv',
                        account: this.$store.state.auth.currentAccountId,
                        operation: (this.superlead.operation_id.id ? this.superlead.operation_id.id : this.superlead.operation_id),
                        rdv: this.superlead.rdv
                    }));
                }
            }
        }
        
        GenericDataService.getData('/hard_value/getValuesByType?type=demand_type').then((response) => {
              let tmpTypes = response.data.data;

              for(const type in tmpTypes) {
                tmpTypes[type].type = type;
                this.demandTypes.push(tmpTypes[type]);
              }
        });
        
        GenericDataService.getData('/hard_value/getValuesArrayByType?type=superlead_temperature').then((response) => {
            this.superleadTemperatures = response.data.data;
        });
    },
    watch: {
        'superlead.contact_id':{
            handler(val){
                if(val && val.id && !this.initDemandCount){
                    GenericDataService.postData('/contact/getSuperleadList?contact_id='+val.id+'&excludeId='+this.superlead.id).then((response) => {
                        this.demandNumber = response.data.data.todeal.length + response.data.data.waiting.length;
                        this.initDemandCount = true;
                    });
                }
            },
            deep:false
        },
        superlead: {
            handler(val, old){
                //watcher pour savoir si on active les boutons d'actions : 
                // règle : si on a au moins une demande ou un rdv de défini et un contact alors on active. au clic sur les boutons d'actions, si non enregistré, on enregistrera le superlead avant de faire l'action cliquée
                this.mainTypeSetted = false;
                
                if ((this.$func.hasRight('lead/add') && this.newSuperlead) || (this.$func.hasRight('lead/update') && !this.newSuperlead)) {
                    this.formDisabled = false;
                } else {
                    this.formDisabled = true;
                }
                if (val.hasOwnProperty('contact_id') && ((val.contact_id.hasOwnProperty('firstname') && val.contact_id.firstname != '') || (val.contact_id.hasOwnProperty('name') && val.contact_id.name != '') || (val.contact_id.hasOwnProperty('company') && val.contact_id.company != ''))) {
                    this.btnDisabled = false;
                } else {
                    this.btnDisabled = true;
                }
                if(val.hasOwnProperty('demands') && val.demands.length > 0){
                    val.demands.forEach(element => {
                        if(element.type == this.operationData.mainType && !this.mainTypeSetted){
                            element['details.mainDemand'] = true;
                            this.mainTypeSetted = true;
                        }
                    });
                }
                
            },
            deep:true,
            immediate:true
        },
        transfert_choice (transfert_choice) {
            this.getUsersForTransfert();
        },
        openExchangeDrawer(val) {
            if(!val)
                this.historyKey++;
        }
    },
    computed: {
        superleadBase: function(){
            return this.$store.state.lead.superleadBase;
        },
        openExchangeDrawer: function(){
            return this.$store.state.exchange.openExchangeDrawer;
        },
        qualifDisabled: function(){
            // Désactiver le bouton "Qualifié" s'il n'y a pas de demandes
            return !this.superlead.hasOwnProperty('demands') || 
                   !this.superlead.demands || 
                   this.superlead.demands.length === 0 ||
                   !this.superlead.demands.some(demand => demand && !['rendez-vous', 'passage', 'inscription'].includes(demand.type));
        },
        enrichedTooltipItems: function() {
            if(!this.superlead || !this.superlead.enrichment_fields) {
                return [];
            }

            if(Array.isArray(this.superlead.enrichment_fields)) {
                return this.superlead.enrichment_fields
                    .filter(field => !!field && typeof field === "object" && (field.reference || field.field))
                    .map(field => {
                        const fieldReference = field.reference || field.field;
                        return `${this.getEnrichedFieldLabel(fieldReference)} : ${this.formatEnrichedFieldValue(field.value, field.to_trad)}`;
                    });
            }

            if(typeof this.superlead.enrichment_fields === "object") {
                return Object.keys(this.superlead.enrichment_fields)
                    .filter(key => Number(this.superlead.enrichment_fields[key]) > 0)
                    .map(key => `${this.getEnrichedFieldLabel(key)} : ${this.superlead.enrichment_fields[key]}`);
            }

            return [];
        },
    },
    methods: {
        formatEnrichedFieldValue(value, toTrad = false) {
            if(value === null || value === undefined || value === "") {
                return "Non renseigné";
            }

            if(typeof value === "boolean") {
                return value ? "Oui" : "Non";
            }

            if(typeof value === "number" && toTrad && (value === 0 || value === 1)) {
                return value === 1 ? "Oui" : "Non";
            }

            if(typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
                const date = new Date(value);
                if(!Number.isNaN(date.getTime())) {
                    return date.toLocaleDateString("fr-FR");
                }
            }

            if(toTrad && typeof value === "string") {
                const translatedValue = this.$t(value);
                if(translatedValue && translatedValue !== value) {
                    return translatedValue;
                }
            }

            return String(value);
        },
        getEnrichedFieldLabel(fieldKey) {
            const translatedField = this.$t(fieldKey);
            if(translatedField && translatedField !== fieldKey) {
                return translatedField;
            }

            return String(fieldKey).replaceAll("_", " ");
        },
        checkBeforeUpdate(){
            this.confirmExitDialog = false;
            this.loader = true;
            GenericDataService.postData('/superlead/checkBeforeUpdate', this.superlead).then((response) => {
                if(response.data.data && response.data.data.title){
                    this.checkBeforeDialogTitle = response.data.data.title;
                    this.checkBeforeDialogText = response.data.data.text;
                    this.checkBeforeDialog = true;
                } else {
                    this.saveAndClose();
                }
            });
        },
        cancelDialog(){
            this.checkBeforeDialog = false;
            this.loader = false;
        },
        goToContact() {
            let routeDataLink = this.$router.resolve({ name: 'ContactDetail', params: { contact_id: this.superlead.contact_id.id } });
            window.open(routeDataLink.href, '_blank');
        },
        changeReportNumber(val){
            this.reportNumber = val
        },
        rdvUserChange(val){
            this.$set(this.superlead, 'affected_user', val)
            this.$set(this.superleadBase, 'affected_user', val)
        },
        cancel(forceExit = false) {
            // Console.log à laisser pour le debug
            console.log("SuperleadBase : ", this.superleadBase);
            console.log("Superlead : ", this.superlead);

            if(!this._.isEqual(this.superleadBase, this.superlead) && !forceExit) {
                this.confirmExitDialog = true;
            } else{
                if (this.socketServer) {
                    this.socketServer.send(JSON.stringify({
                        type: 'close',
                        account: this.$store.state.auth.currentAccountId,
                        operation: (this.superlead.operation_id.id ? this.superlead.operation_id.id : this.superlead.operation_id)
                    }));
                }
                this.$store.dispatch("lead/CLOSE_SUPERLEAD_DIALOG", false);
                this.$emit("reloadRouter");
            }
                
        },
        goToOperationTeam(){
            this.$router.push({name:'OperationsDetailTeam', params: {operation_id:(this.superlead.operation_id.id ? this.superlead.operation_id.id : this.superlead.operation_id)}});
            this.$store.dispatch("lead/CLOSE_SUPERLEAD_DIALOG", false);
        },
        saveAndClose(){
            this.saveSuperlead().then((response) => {
                this.loader = false;
                this.cancel(true);
                this.$emit("reloadRouter");
            }).catch(e => {
                this.loader = false;
            })
        },
        async saveSuperlead() {
            if(this.$refs.sRdv.validateSRdv() && this.validateAllDemand()){
                await new Promise(resolve => setTimeout(resolve, 1));
                await GenericDataService.postData('superlead/saveSuperlead', this.superlead).then((response) => {
                    this.superlead = response.data.data
                    this.$store.dispatch('lead/SET_SUPERLEAD_BASE', response.data.data)
                    this.demandKey++;
                    this.$store.dispatch('ADD_SNACK', { message : this.$t('successActionConfirmed') }).then((e) => { this.$store.dispatch("REMOVE_SNACK") });
                })
            } else {
                this.$store.dispatch('ADD_SNACK', { message : this.$t('errorValidateForm'), type : 'error', icon: '$delete' }).then((e) => { this.$store.dispatch("REMOVE_SNACK") });
                throw new Error('data missing');
            }
        },
        validateAllDemand() {
            if(this.superlead.hasOwnProperty('demands') && this.superlead.demands.length > 0){
                let valid = true
                this.superlead.demands.forEach((element, index) => {
                    if(!this.$refs['SDemand_'+index][0].validateSDemand()){
                        valid = false
                    }                    
                });
                return valid
            }
            return true;
        },
        addDemand(type) {
            this.superlead.demands.push({ "type": type });
        },
        removeDemand(index) {
            this.superlead.demands.splice(index, 1);
            this.demandKey++;
        },
        launchTransfer(){
            this.launchTransferLoader = true;
            this.saveSuperlead().then((response) => {
                this.launchTransferLoader = false;
                this.getUsersForTransfert();
                this.transferDialog = true;
            }).catch(e => {
                this.launchTransferLoader = false;
            })
        },
        transfer() {
            this.transferLoader = true;
            GenericDataService.getData('/superlead/transferSuperlead?id=' + this.superlead.id + '&user_id=' + this.userRadio).then((response) => {
                this.$store.dispatch('ADD_SNACK', { message : this.$t('successActionConfirmed') }).then((e) => { this.$store.dispatch("REMOVE_SNACK") });
                this.transferLoader = false;
                this.cancel(true);
                this.$emit("reloadRouter");
            }).catch(e => {
                this.transferLoader = false;
            })
        },
        getUsersForTransfert() {
            if(this.transfert_choice === "TEAM") {
                GenericDataService.getData('user/selectListForTransfertTable').then((response) => {
                    this.team = response.data.data
                });
            } else {
                let url = '/operation/{{operation_id}}/getTeamActive?withUsersToStop=0&entityId={{entity_id}}';
                url = url.replace('{{operation_id}}', (this.superlead.operation_id.id ? this.superlead.operation_id.id : this.superlead.operation_id));
                url = url.replace('{{entity_id}}', (this.superlead.entity_id.id ? this.superlead.entity_id.id : this.superlead.entity_id));
                GenericDataService.getData(url).then((response) => {
                    this.team = response.data.data
                    if(this.superlead.rdv)
                        this.team = this.team.filter((user) => user.confPlanning);
                });
            }
        },
        selectUser(id) {
           this.userRadio = id 
        },
        launchAbandon() {
            this.launchAbandonLoader = true;
            this.saveSuperlead().then((response) => {
                this.launchAbandonLoader = false;
                this.getForm('/superlead/getForm?formName=abandon&id=' + this.superlead.id);
            }).catch(e => {
                this.launchAbandonLoader = false;
            })
        },
        launchReport() {
            this.launchReportLoader = true;
            this.saveSuperlead().then((response) => {
                this.launchReportLoader = false;
                this.getForm('/superlead/getForm?formName=report&id=' + this.superlead.id);
            }).catch(e => {
                this.launchReportLoader = false;
            })
        },
        launchQualif() {
            this.launchQualifLoader = true;
            this.saveSuperlead().then((response) => {
                this.launchQualifLoader = false;
                this.getForm('/superlead/getQualifForm?id=' + this.superlead.id, false, { event: 'refreshAfterQualif', returnFullObject: true });
            }).catch(e => {
               this.launchQualifLoader = false;
            })
        },
        refreshAfterQualif() {
            // La réponse de qualifSuperlead contient le lead avant enregistrement : on le recharge sans fermer la fiche
            GenericDataService.getData('superlead/' + this.superlead.id + '/get').then((response) => {
                this.$store.dispatch('lead/SET_SUPERLEAD_BASE', response.data.data);
                this.superlead = this._.cloneDeep(response.data.data);
                this.demandKey++;
                this.historyKey++;
            });
        },
        launchGetInTouch() {
            this.launchGetInTouchLoader = true;
            GenericDataService.getData('/contact/' + this.superlead.contact_id.id + '/get').then((response) => {
                this.$store.dispatch("contact/SET_CONTACT_DATA", response.data.data);
                this.$store.dispatch("exchange/SET_OPEN_EXCHANGE_DRAWER", { value: true, superlead: this.superlead });
                this.launchGetInTouchLoader = false;
            }).catch(e => {
                this.launchGetInTouchLoader = false;
            })
        },
        customRefresh() {
            this.cancel(true);
            this.$emit("reloadRouter");
        },
        checkOperationData() {
            GenericDataService.getData('/operation/' + (this.superlead.operation_id.id ? this.superlead.operation_id.id : this.superlead.operation_id) + '/checkOperationData').then((response) => {
            this.operationData = response.data.data
        });
        }
    }
}
</script>

<style lang="scss">
    .superlead-card {
        .heading{
            display:flex;
            justify-content: space-between;
            align-items:center;
            .header-div {
                display: flex;
                align-items: center;
                .label {
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }

        .icon_selector {
            max-width: fit-content;
            input {
                width: 0;
            }
            .v-input__slot {
                box-shadow: 3px 3px 10px -1px rgba(0, 0, 0, 0.11) !important;
            }
        }
    }
</style>